import api from '@/api';

const store = {
  state: {
    billListItems: [],
    isBillLoadingShow: false,
    billListCount: [],
    pagingBillReport: {
      page: 1,
      size: 20,
      total: 0
    },
    isNewOrder: false,
    includeAllMenu: {}
  },

  mutations: {
    SET_BILL_PAGING: (state, payload) => {
      state.pagingBillReport.page = payload;
    },
    SET_BILL_TOTAL: (state, payload) => {
      state.pagingBillReport.total = payload;
    },
    SET_BILL_SIZE: (state, payload) => {
      state.pagingBillReport.size = payload;
    },
    SET_BILL_LIST_ITEMS: (state, payload) => {
      state.billListItems = payload;
    },
    SET_BILL_LOADINGSHOW: (state, payload) => {
      state.isBillLoadingShow = payload;
    },
    SET_BILL_LIST_COUNT: (state, payload) => {
      state.billListCount = payload;
    },
    SET_IS_NEW_ORDER: (state, payload) => {
      state.isNewOrder = payload;
    },
    SET_INCLUDEALLMENU: (state, payload) => {
      state.includeAllMenu = payload;
    }
  },

  getters: {
    GetBillPaging: state => state.pagingBillReport,
    GetBillList: state => state.billListItems,
    GetBillLodaing: state => state.isBillLoadingShow,
    GetBillListCount: state => state.billListCount,
    GetIsNewOrder: state => state.isNewOrder,
    GetIncludeAllMenu: state => state.includeAllMenu
  },

  actions: {
    async GetAllBillList({ commit, state }, payload) {
      try {
        commit('SET_BILL_LOADINGSHOW', true);
        const result = await api.GetAllBillList(
          payload,
          state.pagingBillReport
        );
        commit('SET_BILL_LIST_ITEMS', result.data.result.list);
        commit('SET_INCLUDEALLMENU', result.data.result.menu_items);
        commit('SET_BILL_LIST_COUNT', result.data.result.counts);
        commit('SET_BILL_LOADINGSHOW', false);
        return result;
      } catch (error) {
        console.log(error);
        commit('SET_BILL_LOADINGSHOW', false);
      }
    },

    async UpdateBillStatus({ commit }, payload) {
      try {
        commit('SET_BILL_LOADINGSHOW', true);
        const result = await api.UpdateBillStatus(payload);
        commit('SET_BILL_LOADINGSHOW', false);
        return result;
      } catch (e) {
        commit('SET_BILL_LOADINGSHOW', false);
        return e.response;
      }
    },

    async UpdateBillDiscount({ commit }, payload) {
      try {
        commit('SET_BILL_LOADINGSHOW', true);
        const result = await api.UpdateBillDiscount(payload);
        commit('SET_BILL_LOADINGSHOW', false);
        return result;
      } catch (e) {
        commit('SET_BILL_LOADINGSHOW', false);
        return e.response;
      }
    }
  }
};

export default store;
